import { render, staticRenderFns } from "./BusySpinner.vue?vue&type=template&id=28570c42&functional=true"
import script from "./BusySpinner.vue?vue&type=script&lang=js"
export * from "./BusySpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports